import React, { useEffect, useState } from 'react';
import { Box, Alert, AlertTitle } from '@mui/material';
import DashboardHeader from '../components/common/DashboardHeader';
import HotelPerformanceDashboard from '../components/performance/HotelPerformanceDashboard';
import { getDashboardPageShellSx } from '../utils/dashboardSurfaceSx';
import { isInsightsTabletLayout } from '../utils/insightsDashboardLayout';
import { detectThemeSync, watchThemeChanges } from '../utils/themeUtils';

/**
 * Hotel performance route: same chart set as landing overview, scoped to DJANGO_CONTEXT.selectedHotel.
 */
export default function PerformanceDashboardPage() {
  const djangoContext = window.DJANGO_CONTEXT || {};
  const selectedHotel = djangoContext.selectedHotel || null;

  const [currentTheme, setCurrentTheme] = useState(() => detectThemeSync());

  useEffect(() => {
    const cleanup = watchThemeChanges((next) => setCurrentTheme(next));
    return cleanup;
  }, []);

  const isTabletLayout = isInsightsTabletLayout();

  return (
    <Box sx={{
      ...getDashboardPageShellSx(currentTheme),
      ...(isTabletLayout ? { p: { xs: 1.5, sm: 2 } } : {}),
    }}>
      <Box sx={{ mb: 3 }}>
        <DashboardHeader
          title="Performance"
          breadcrumbs={[
            { label: 'Home', path: '/dashboard/' },
            { label: 'Performance' },
          ]}
          navLinks={[
            { url: '/dashboard/', label: 'Dashboard' },
            { url: '/booking/dashboard/', label: 'Booking Dashboard' },
            { url: '/finance/', label: 'Finance' },
          ]}
        />
      </Box>

      {!selectedHotel && (
        <Box sx={{ mb: 3 }}>
          <Alert severity="warning" sx={{ borderRadius: 2 }}>
            <AlertTitle>No hotel selected</AlertTitle>
            Pick a hotel from the header menu to scope analytics. You can still open the{' '}
            <a href="/onboarding/landing/" style={{ color: 'inherit', textDecoration: 'underline' }}>
              landing page
            </a>{' '}
            to switch properties.
          </Alert>
        </Box>
      )}

      <HotelPerformanceDashboard hotel={selectedHotel} />
    </Box>
  );
}
